import {
    AppBar,
    Button,
    Toolbar,
    Box,
    Drawer,
    IconButton,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    useMediaQuery,
    useTheme
} from "@mui/material";
import React, {useEffect, useState, useRef} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import styles from "./TopNavBar.module.scss";
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ArchiveOutlinedIcon from '@mui/icons-material/ArchiveOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SupervisorAccountOutlinedIcon from '@mui/icons-material/SupervisorAccountOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import {formatDateTime} from "../../Helpers/Helpers";
import CommonDialog from "../Shared/CommonDialog/CommonDialog";

const navItems = [
    {
        label: 'CHOOSE YOUR GUARDIAN',
        icon: <SupervisorAccountOutlinedIcon fontSize="small" className={"muiButtonIcon"}/>,
        url: "/choose-guardian",
        theme: 'olive',
        className: "menu-choose-guardian",
        mobileColorObj: {
            drawerBackGroundColor: '#c4c8ab',
            activeItemBackGroundColor: '#647045',
            lefItemBackGroundColor: '#a8b87a',
            visibleTabButton: 'visible',
            buttonBackGroundColor: '#ffffff99',
            buttonColor: '#687543',
        }
    },
    {
        label: 'START SCAM IDENTIFICATION',
        icon: <GavelOutlinedIcon fontSize="small" className={"muiButtonIcon"}/>,
        url: "/StartIdentifyScam",
        theme: 'olive',
        className: "menu-scam-identification",
        mobileColorObj: {
            drawerBackGroundColor: '#c4c8ab',
            activeItemBackGroundColor: '#647045',
            lefItemBackGroundColor: '#a8b87a',
            visibleTabButton: 'visible',
            buttonBackGroundColor: '#ffffff99',
            buttonColor: '#687543',
        }
    },
    {
        label: 'SCAM EDUCATION',
        icon: <SchoolOutlinedIcon fontSize="small" className={"muiButtonIcon"}/>,
        url: "/scam-education",
        theme: 'teal',
        className: "menu-scam-education",
        mobileColorObj: {
            drawerBackGroundColor: '#76919e8f',
            activeItemBackGroundColor: 'rgb(24 71 92)',
            lefItemBackGroundColor: '#99c8dd',
            visibleTabButton: 'hidden',
            buttonBackGroundColor: '#d3dbe0',
            buttonColor: '##18475c',
        }
    },
    {
        label: 'ANTI-SCAM DEFENCES',
        icon: <SecurityOutlinedIcon fontSize="small" className={"muiButtonIcon"}/>,
        url: "/anti-scam-defenders",
        theme: 'sepiaVintage',
        className: "menu-anti-scam-defenders",
        mobileColorObj: {
            drawerBackGroundColor: '#9480659e',
            activeItemBackGroundColor: '#553c1a',
            lefItemBackGroundColor: '#bbaa91',
            visibleTabButton: 'hidden',
            buttonBackGroundColor: '#ffffff99',
            buttonColor: '#553c1a',
        }
    },
    {
        label: 'CONTRIBUTION & COMMUNITY',
        icon: <GroupsOutlinedIcon fontSize="small" className={"muiButtonIcon"}/>,
        url: "/contribution-community",
        theme: 'tealDominant',
        className: "menu-contribution-community",
        mobileColorObj: {
            drawerBackGroundColor: '#616ead',
            activeItemBackGroundColor: '#2c346c',
            lefItemBackGroundColor: '#959dc3',
            visibleTabButton: 'hidden',
            buttonBackGroundColor: '#ffffff99',
            buttonColor: '#1c2e50',
        }
    },
    {
        label: 'ARCHIVES',
        icon: <ArchiveOutlinedIcon fontSize="small" className={"muiButtonIcon"}/>,
        url: "/archives",
        theme: 'beOlive',
        className: "menu-archives",
        mobileColorObj: {
            drawerBackGroundColor: '#b464607a',
            activeItemBackGroundColor: '#773b3d',
            lefItemBackGroundColor: '#d98183',
            visibleTabButton: 'hidden',
            buttonBackGroundColor: '#cfa789',
            buttonColor: '#832f37',
            // drawerBackGroundColor: 'rgb(255 255 255 / 27%)',
            // drawerBackGroundColor: '#b464607a',
        }
    },
];

type Props = {
    onThemeChange: (themeName: string) => void;
};

export const TopNavBar: any = ({onThemeChange}: Props) => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentPath = location.pathname;
    const lastSegment = currentPath.split('/').filter(Boolean).pop();
    const navRef = useRef<any>(null);

    const [openConfirm, setOpenConfirm] = useState(false);
    const [pendingNavItem, setPendingNavItem] = useState<any>(null);

    // Mobile drawer state
    const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileColorObj, setMobileColorObj] = useState<any>(navItems[0].mobileColorObj);
//-----------------------------------------------------------------------------------------------
// Dynamically set CSS variable for navbar height to ensure content is not hidden behind it
    useEffect(() => {
        const updateNavbarHeight = () => {
            const height = navRef.current?.offsetHeight || 96;
            console.log("Navbar height:", height);
            document.documentElement.style.setProperty(
                "--navbar-height",
                `${height}px`
            );
        };

        updateNavbarHeight(); // lần đầu

        window.addEventListener("resize", updateNavbarHeight);

        return () => {
            window.removeEventListener("resize", updateNavbarHeight);
        };
    }, []);
    //

    const handleMobileDrawerToggle = () => {
        setMobileDrawerOpen(!mobileDrawerOpen);
    };

    const handleMobileNavClick = (item: any) => {
        setMobileDrawerOpen(false);
        handleClick(item);
    };

    const handleClick = (item: any) => {
        const scamStarted = localStorage.getItem("scamStarted") === "true";
        const currentNodeId = localStorage.getItem("currentNodeId");
        const currentNodeType = localStorage.getItem("currentNodeType"); // 👈 check node type

        if (scamStarted && currentNodeId) {
            if (currentNodeType === "end") {
                setPendingNavItem(item);
                handleAutoSaveAndContinue();
            } else {
                setPendingNavItem(item);
                setOpenConfirm(true);
            }
        } else {
            navigate(item.url);
            onThemeChange(item.theme);
        }
    };

    useEffect(() => {
            const item = navItems.find(item => item.url?.split('/').pop() === lastSegment)
            onThemeChange(item?.theme ?? 'olive');
            if (isMobile)
                setMobileColorObj(item?.mobileColorObj ?? navItems[0].mobileColorObj)
        },
        [navigate, location, onThemeChange, lastSegment])

    const handleContinue = () => {
        // clear localStorage
        localStorage.removeItem("scamStarted");
        localStorage.removeItem("currentNodeId");
        localStorage.removeItem("qTrail");
        localStorage.removeItem("interactionHistory");

        setOpenConfirm(false);

        if (pendingNavItem) {
            navigate(pendingNavItem.url);
            onThemeChange(pendingNavItem.theme);
            setPendingNavItem(null);
        }
    };

    const handleAutoSaveAndContinue = () => {
        const rawHistory = localStorage.getItem("interactionHistory");
        const history = rawHistory ? JSON.parse(rawHistory) : [];

        const now = new Date();
        const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}_${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
        const autoFileName = `interaction-history-${timestamp}.txt`;

        const contents = history
            .map((item: any, i: number) => `${i + 1}. ${item.time}: ${item.label}${item.detail ? " - " + item.detail : ""}`);
        const endTime = formatDateTime();
        const endAction = `${contents.length + 1}. ${endTime}: Switch To Another Action`;
        const downloadContent = [...contents, endAction].join("\n");

        const blob = new Blob([downloadContent], {type: "text/plain;charset=utf-8"});
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = autoFileName;
        link.click();

        // clear localStorage
        localStorage.removeItem("scamStarted");
        localStorage.removeItem("currentNodeId");
        localStorage.removeItem("qTrail");
        localStorage.removeItem("interactionHistory");
        localStorage.removeItem("currentNodeType");

        // điều hướng
        if (pendingNavItem) {
            navigate(pendingNavItem.url);
            onThemeChange(pendingNavItem.theme);
            setPendingNavItem(null);
        }
    };


    return (
        <>
            <AppBar position="static" elevation={0}
                    ref={navRef}
                    className="top-menu-bar" style={{
                position: "relative",
                zIndex: 2
            }}>
                <Toolbar sx={{justifyContent: 'center'}}>
                    {/* Mobile Hamburger Menu + Nav Buttons */}
                    {isMobile && (
                        <Box
                            id={'mobile-menu-button-container'}
                            sx={{
                                position: 'absolute',
                                left: 0,
                                right: 0,
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                height: '100%',
                                px: 0.5,
                                gap: 0.5,
                            }}>
                            {/* Hamburger Menu Button */}
                            <IconButton
                                id={'mobile-menu-button'}
                                color="inherit"
                                aria-label="open navigation menu"
                                edge="start"
                                onClick={handleMobileDrawerToggle}
                                sx={{color: 'white', flexShrink: 0, marginLeft: 0, padding: '6px'}}
                            >
                                <MenuIcon id={'mobile-menu-button-icon'}/>
                            </IconButton>

                            {/* Back Button */}
                            <IconButton
                                id={'mobile-back-button'}
                                color="inherit"
                                aria-label="Go back"
                                onClick={() => navigate(-1)}
                                sx={{
                                    color: 'white',
                                    flexShrink: 0,
                                    width: '5%',
                                    minWidth: 32,
                                    padding: '6px',
                                }}
                            >
                                <ArrowBackIosNewIcon sx={{fontSize: 18}}/>
                            </IconButton>

                            {/* System Button – mirrors MobileBottomPanel openMessageBoxButton */}
                            <Button
                                className="openMessageBox topbar-openMessageBoxButton"
                                onClick={() => {
                                    const btn = document.querySelector('.openMessageBoxButton') as HTMLElement;
                                    if (btn) btn.click();
                                }}
                                sx={{
                                    flex: '45 1 0',
                                    minWidth: 0,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                    letterSpacing: '0.3px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 0.5,
                                    borderRadius: '8px',
                                    height: '36px',
                                    background: mobileColorObj.buttonBackGroundColor, // sử dụng màu nền từ mobileColorObj
                                    color: mobileColorObj.buttonColor, // sử dụng màu chữ từ mobileColorObj
                                    border: '1px solid rgba(255,255,255,0.15)',
                                    visibility: mobileColorObj.visibleTabButton, // điều chỉnh hiển thị dựa trên từng tab
                                    '&:hover': {
                                        background: 'rgba(255,255,255,0.15)',
                                    },
                                }}
                            >
                                MESSAGES
                            </Button>

                            {/* Interaction Button – mirrors MobileBottomPanel openInteractionBoxButton */}
                            <Button
                                className="openInteractionBox topbar-openInteractionBoxButton"
                                onClick={() => {
                                    const btn = document.querySelector('.openInteractionBoxButton') as HTMLElement;
                                    if (btn) btn.click();
                                }}
                                sx={{
                                    flex: '45 1 0',
                                    minWidth: 0,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    fontWeight: 600,
                                    letterSpacing: '0.3px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: 0.5,
                                    borderRadius: '8px',
                                    height: '36px',
                                    visibility: mobileColorObj.visibleTabButton,
                                    background: mobileColorObj.buttonBackGroundColor, // sử dụng màu nền từ mobileColorObj
                                    color: mobileColorObj.buttonColor, // sử dụng màu chữ từ mobileColorObj
                                    border: '1px solid rgba(255,255,255,0.15)',
                                    '&:hover': {
                                        background: 'rgba(255,255,255,0.15)',
                                    },
                                }}
                            >
                                HISTORY
                            </Button>

                            {/* Next Button */}
                            <IconButton
                                id={'mobile-next-button'}
                                color="inherit"
                                aria-label="Go forward"
                                onClick={() => navigate(1)}
                                sx={{
                                    color: 'white',
                                    flexShrink: 0,
                                    width: '5%',
                                    minWidth: 32,
                                    padding: '6px',
                                }}
                            >
                                <ArrowForwardIosIcon sx={{fontSize: 18}}/>
                            </IconButton>
                        </Box>
                    )}

                    {/* Desktop Navigation - Hidden on mobile */}
                    <Box
                        className={styles.topNavContainer}
                        sx={{display: {xs: 'none', md: 'grid'}}}
                    >
                        {navItems.map((item, index) => (
                            <Box key={index} sx={{position: 'relative'}} className={styles.topNavButtonWrapper}>
                                <Button
                                    onClick={() => item && handleClick(item)}
                                    className={`${lastSegment === item.url?.split('/').pop() ? "active" : ""} ${styles.topNavButton} ${item.className}`}
                                    fullWidth
                                    variant="contained"
                                >
                                    {item.label}
                                    <Box sx={{position: 'absolute', top: 6, right: 8, opacity: 0.9}}>
                                        {item.icon}
                                    </Box>
                                </Button>
                            </Box>
                        ))}
                    </Box>
                </Toolbar>
            </AppBar>

            {/* Mobile Drawer */}
            <Drawer
                id={'mobile-menu-drawer'}
                variant="temporary"
                anchor="left"
                open={mobileDrawerOpen}
                onClose={handleMobileDrawerToggle}
                ModalProps={{
                    keepMounted: true, // Better mobile performance
                }}
                sx={{
                    display: {xs: 'block', md: 'none'},
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        width: 300,
                        background: mobileColorObj.drawerBackGroundColor || 'rgb(255 255 255 / 27%)',
                        borderRight: '1px solid rgba(255, 255, 255, 0.1)',
                    },
                    '& .MuiBackdrop-root': {
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    },
                }}
            >
                {/* Drawer Header */}
                <Box sx={{
                    px: 2.5,
                    py: 2,
                    borderBottom: '1px solid rgb(255 255 255 / 80%)',
                    mb: 1
                }}>
                    <Box sx={{
                        fontWeight: 700,
                        color: 'white',
                        textTransform: 'uppercase',
                    }}
                         className={styles.navigationTitle}>
                        Navigation
                    </Box>
                </Box>

                {/* Navigation List */}
                <Box sx={{px: 1.5, pb: 2}}>
                    <List disablePadding id={'mobile-menu-list'}>
                        {navItems.map((item, index) => {
                            const isActive = lastSegment === item.url?.split('/').pop();
                            return (
                                <ListItem key={index} disablePadding sx={{mb: 0.5}}>
                                    <ListItemButton
                                        className={`mobile-${item.className}`}
                                        onClick={() => handleMobileNavClick(item)}
                                        selected={isActive}
                                        sx={{
                                            py: 1.5,
                                            px: 2,
                                            borderRadius: '10px',
                                            transition: 'all 0.2s ease',

                                            // Default state
                                            backgroundColor: mobileColorObj.buttonBackGroundColor,

                                            // Hover state
                                            '&:hover': {
                                                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                                            },

                                            // Active/Selected state
                                            '&.Mui-selected': {
                                                // backgroundColor: 'rgba(134, 144, 100, 0.35)',
                                                backgroundColor: mobileColorObj.activeItemBackGroundColor,
                                                borderLeft: `3px solid ${mobileColorObj.lefItemBackGroundColor}`,
                                                '&:hover': {
                                                    backgroundColor: 'rgba(134, 144, 100, 0.45)',
                                                },
                                            },
                                        }}
                                    >
                                        <ListItemIcon sx={{
                                            minWidth: 36,
                                            color: isActive ? '#c4d4a0' : 'rgba(255, 255, 255, 0.7)',
                                        }}>
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={item.label}
                                            slotProps={{
                                                primary: {
                                                    sx: {
                                                        fontSize: '0.95rem!important',
                                                        fontWeight: 700,
                                                        color: isActive ? '#ffffff!important' : mobileColorObj.buttonColor,
                                                        // color: isActive ? '#ffffff' : 'rgb(104, 117, 67)',
                                                        // color: mobileColorObj.buttonColor,
                                                        letterSpacing: '0.3px',
                                                        lineHeight: 1.4,
                                                    }
                                                }
                                            }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            );
                        })}
                    </List>
                </Box>
            </Drawer>

            {/* Confirm Dialog */}
            <CommonDialog
                open={openConfirm}
                title="Warning"
                imageSrc="/assets/cyborg-bear-1.png"
                content={
                    <>
                        <strong>
                            You are currently in the process of Scam Identification.
                            If you switch to another tab, the entire progress will be lost.
                            Do you want to continue?
                        </strong>
                    </>
                }
                onConfirm={handleContinue}
                onClose={() => setOpenConfirm(false)}
                confirmText="Continue"
                cancelText="Cancel"
                dialogClassName="cfm-switch-tab-dialog"
                confirmButtonClassName="cfm-switch-tab-continue-btn"
                cancelButtonClassName="cfm-switch-tab-cancel-btn"
            />

        </>
    );
};
